/* globals process */

import API from './../api';

export default {
	state: {
		user: null,
		token: '',
		firebaseToken: '',
		impersonating: false,
	},
	getters: {
		user: state => state.user,
		loggedIn: state => !!state.token,
		can: (state) => (permission) => {
			return state.user && state.user.can && state.user.can[permission];
		}
	},
	mutations: {
		setUser(state, {token, user}) {
			state.token = token;
			state.user = user;
		},
		clearUser(state) {
			state.token = '';
			state.user = null;
			state.impersonating = false;
		},
		setToken(state, token) {
			state.token = token;
		},
		setImpersonating(state, impersonating) {
			state.impersonating = !!impersonating;
		},
		updateProfile(state, user) {
			state.user = user;
		},
	},
	actions: {
		login({commit, state}, {username, password}) {
			return API.login(username, password).then(response => {
                console.log("User: ",response.data);
				commit('setUser', {
					token: response.data.token,
					user: response.data.user,
				});
			});
		},
		logout({commit, dispatch}) {
			commit('clearUser');

			return Promise.resolve();
		},
		updateProfile({commit}, data) {
			return API.updateProfile(data).then(user => {
				commit('updateProfile', user);
				return user;
			});
		},
		fetchProfile({commit}) {
			return API.getProfile().then(user => {
				commit('updateProfile', user);
				return user;
			});
		},
		impersonateUser({commit}, data) {
            commit('resetRegistration', null);
            commit('modifyEventLoading', true);
			return API.impersonateUser(data.id).then(async (response) => {
				commit('setUser', {
					token: response.data.token,
					user: response.data.user,
				});
				commit('setImpersonating', true);

                console.log("Event: ", data.event);
                if(data.event && data.event.id) {
                    await API.isUserSubscribed(data.event.id).then(evResponse => {
                        console.log("Response: ", evResponse);
                        if(evResponse) {
                            commit('modifyRegistrationComplete', true);
                        } else {
                            commit('modifyRegistrationComplete', false);
                        }
                    });
                }

                commit('modifyEventLoading', false);
			});
		},
		leaveImpersonation({commit}, event) {
			return API.leaveImpersonation().then(response => {
				commit('setUser', {
					token: response.data.token,
					user: response.data.user,
				});
				commit('setImpersonating', false);
                if(event && event.id) {
                    API.isUserSubscribed(event.id).then(evResponse => {
                        console.log("Response: ", evResponse);
                        if(evResponse) {
                            commit('modifyRegistrationComplete', true);
                        } else {
                            commit('modifyRegistrationComplete', false);
                        }
                    });
                }
			});
		},
	},
}
